import 'rangeslider.js';
import 'jquery-match-height';
import 'slick-carousel';
import 'sticky-kit/dist/sticky-kit.min';

const debounce = require('lodash.debounce');

window.app           = window.app || {};
window.app.loadModal = function(url) {
    return $.ajax({
        url: url,
    }).done(function(data) {
        $('.modal').on('hidden.bs.modal', function() {
            $(this).modal('dispose');
        }).modal('hide');
        const $contents = $(data);
        $contents.on('shown.bs.modal', function() {
            window.app.loadComponentsFor($contents);
        }).modal({
            backdrop: $('[data-dismiss="modal"]', $contents).length > 0 ? true : 'static'
        });
    }).fail((xhr) => {
        if (xhr.statusText === 'abort') {
            return;
        }
        // TODO show error modal
    });
};

/*
 * Override initialization of slick sliders
 * to ensure height matching is updated after
 */
const slickInit = $.fn.slick;
$.fn.slick      = function() {
    $(this).on('init', () => {
        $.fn.matchHeight._update();
    });
    return slickInit.apply(this, arguments);
};

/**
 * Select elements within the container,
 * taking into account that the container might be the first selector's element
 *
 * @param {String} selector
 * @param {jQuery} $container
 * @returns {jQuery}
 */
$.containerOrSelf = (selector, $container) => {
    selector                = selector.split(' ');
    const selfSelector      = selector[0];
    const remainderSelector = selector.slice(1).join(' ');
    if ($container.is(selfSelector)) {
        return remainderSelector.length > 1 ? $(remainderSelector, $container) : $container;
    }
    return $(`${selfSelector} ${remainderSelector}`, $container);
};

$(document).ajaxComplete((event, xhr) => {
    // Handle global credit notice show based on header
    const flag = xhr.getResponseHeader('app-global-credit-notice');
    if (flag === '?1') {
        $('.js-global-credit-notice').show();
    }
})

const initializeSticky = ($container) => {
    $.containerOrSelf('.js-stick-receipt > .receipt:visible', $container).stick_in_parent({offset_top: 5});
};

const initializeTabs = ($container) => {
    // Load active tab based on URL hash once
    if ($container.is('body')) {
        let url = document.location.toString();
        if (url.match('#')) {
            $('[role="tablist"] a[href="#' + url.split('#')[1] + '"]').tab('show');
        }
    }

    let $href = $('.js-tabs li.is-active a', $container).attr('href');
    $($href).fadeIn().siblings().hide();
    $('.js-tabs li a', $container).click(function(e) {
        e.preventDefault();
        let $href = $(this).attr('href');

        $($href).fadeIn().siblings().hide();
        $(this).parent().addClass('is-active').siblings().removeClass('is-active');
    });

    // Reinitialize sticky containers after activating a tab
    $('[data-toggle="tab"]', $container).on('shown.bs.tab', function (e) {
        let targetSelector = $(this).attr('href');
        if (!targetSelector) {
            return;
        }
        let $target = $(targetSelector);
        initializeSticky($target);
    })

    // Change hash for page-reload
    $('[role="tablist"] a').on('shown.bs.tab', function(e) {
        window.location.hash = e.target.hash;
    })
};

const initializeModals = ($container) => {
    $('a[href*=".modal"]', $container).on('click', function(e) {
        e.preventDefault();
        const $anchor = $(this);
        $anchor.toggleClass('loading disabled', $anchor.hasClass('btn'));
        window.app
            .loadModal($anchor.attr('href'))
            .always(function() {
                $anchor.removeClass('loading disabled');
            });
    });
}

export default ($container) => {
    // Range inputs
    $('input[type="range"]', $container).rangeslider({
        polyfill: false,
    });
    $('.rangeslider', $container).each(function() {
        let id = $(this).attr('id');
        $(this).next('#' + id).remove();
    });

    // Counter inputs
    const changeQuantity = (diff) => {
        return function(e) {
            e.preventDefault();
            const $input    = $(this).siblings(':input');
            let newQuantity = parseInt($input.val()) + diff;
            newQuantity     = Math.max($input.attr('min') || 0, newQuantity);
            newQuantity     = Math.min($input.attr('max') || 100, newQuantity);
            $input.val(newQuantity).trigger('change');
        };
    };
    $('.js-counter-plus', $container).click(changeQuantity(1));
    $('.js-counter-minus', $container).click(changeQuantity(-1));
    $('form > .js-counter input[type="number"]', $container).on('change', debounce(function() {
        $(this).closest('form').submit();
    }, 250));

    // Match height
    $('[data-mh]', $container).sort(function(a, b) {
        return $(a).data('mh').localeCompare($(b).data('mh'));
    }).matchHeight();

    // Tooltips
    $('[data-toggle="tooltip"]', $container).tooltip();

    // Tabs
    initializeTabs($container);

    // Sticky content
    initializeSticky($container);

    // Modals
    initializeModals($container);

    // Checkbox and select urls
    $('.js-select-url, .js-checkbox-url', $container).on('change', function(e) {
        e.preventDefault();
        const $trigger = $(this);
        const href     = $trigger.val();
        if (href.indexOf('.modal') !== -1) {
            $trigger.addClass('loading');
            window.app.loadModal(href)
                .done(function() {
                    // Swap toggled values
                    if ($trigger.is('.js-checkbox-url')) {
                        const toggle = $trigger.data('toggled-value');
                        if (typeof toggle === 'string') {
                            $trigger.val(toggle).data('toggled-value', href);
                        }
                    }
                })
                .fail((xhr) =>  {
                    if ($trigger.is('.js-checkbox-url')) {
                        // Persist previous checked state, assume toggle failed
                        $trigger.prop(':checked', !$trigger.prop(':checked'));
                    }
                })
                .always(function() {
                    $trigger.removeClass('loading');
                });
        } else {
            window.location = href;
        }
    });

    // Generic navbar scrolling
    $('.js-nav-scroll a, a.js-nav-scroll', $container).click(function(e) {
        e.preventDefault();
        let href = $(this).attr('href');
        $('body, html').animate({
            scrollTop: `${$(href).offset().top}px`,
        }, 700);
    });

    // Search with dropdowns
    $('.js-search form', $container).on('submit', function(e) {
        e.preventDefault();
        const query     = $(':input[name="query"]:visible', this).val();
        const $dropdown = $(this).closest('.js-search.dropdown');
        const $menu     = $('.dropdown-menu', $dropdown);
        const $toggle   = $('[data-toggle="dropdown"]', $dropdown);
        $menu.addClass('loading');

        let activeXhr = $(this).data('xhr');
        if (activeXhr) {
            activeXhr.abort();
        }

        if (query.length === 0) {
            $toggle.dropdown('hide');
        } else {
            $toggle.dropdown('show');
            const xhr = $.ajax({
                method: 'get',
                url:    $(this).attr('action'),
                data:   {query: query},
            }).done(function(data) {
                $menu.html(data).removeClass('loading');
            });
            $(this).data('xhr', xhr);
        }
    });
    $('.js-search form :input[name="query"]', $container).on('keyup', debounce(function(e) {
        $(this).closest('form').trigger('submit');
    }, 750));
};
